import React, { useState, useContext } from "react";
import { Button } from "../../../components";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "../../../redux/store";
import { getOffice, setOfficeAcceptedTerms } from "../../../redux/slices/OfficeSlice";
import { AuthPermission } from "../../../services/auth.service";
import { ToastContext } from "../../../contexts/ToastContext/ToastContext";
import { TermsOfUseContent, PrivacyPolicyContent } from "../../../components";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const LegalTab = () => {
  const dispatch: AppDispatch = useDispatch();
  const { currentOffice } = useSelector((state: RootState) => state.office);
  const { currentUser } = useSelector((state: RootState) => state.currentUser);
  const toast = useContext(ToastContext);

  const permissionToClick = !currentUser?.permissions.includes(AuthPermission.Legal);
  const [acceptTerm, setAcceptTerm] = useState(currentOffice?.acceptedTerms);
  const [expandedTerms, setExpandedTerms] = useState(false);
  const [expandedPrivacy, setExpandedPrivacy] = useState(false);

  const handleClick = () => {
    if (currentOffice?.officeId) {
      dispatch(setOfficeAcceptedTerms({ officeId: currentOffice?.officeId, acceptedTerms: true })).then(() => {
        if (currentOffice?.officeId) dispatch(getOffice({ officeId: currentOffice.officeId }));
      });
    }
  };
  const handlePermissionClick = () => {
    if (!permissionToClick) {
      setAcceptTerm(true);
      handleClick();
    } else {
      toast?.openToast("Terms + Conditions must be accepted by a user with legal permissions");
    }
  };

  return (
    <>
      <div className="">
        <div className="flex justify-between items-center mb-6">
          <h2 className="heading uppercase mb-0">Legal</h2>
          {!acceptTerm ? (
            <Button className={`${!permissionToClick ? "" : "opacity-30"}`} text="Accept Terms of Use" onClick={() => handlePermissionClick()} />
          ) : null}
        </div>

        <div className="space-y-4">
          {/* Terms of Use Accordion */}
          <Accordion
            expanded={expandedTerms}
            onChange={() => setExpandedTerms(!expandedTerms)}
            sx={{
              boxShadow: "none",
              border: "1px solid #e5e7eb",
              borderRadius: "8px !important",
              "&:before": {
                display: "none",
              },
              backgroundColor: "#fff",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#6b7280" }} />}
              sx={{
                padding: "16px 24px",
                "& .MuiAccordionSummary-content": {
                  margin: "0 !important",
                },
              }}
            >
              <span className="text-lg font-semibold text-gray-800">Terms of Use</span>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0 24px 24px 24px", backgroundColor: "transparent" }}>
              <div className="max-h-[500px] overflow-y-auto border-t pt-4">
                <TermsOfUseContent />
              </div>
            </AccordionDetails>
          </Accordion>

          {/* Privacy Policy Accordion */}
          <Accordion
            expanded={expandedPrivacy}
            onChange={() => setExpandedPrivacy(!expandedPrivacy)}
            sx={{
              boxShadow: "none",
              border: "1px solid #e5e7eb",
              borderRadius: "8px !important",
              "&:before": {
                display: "none",
              },
              backgroundColor: "#fff",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#6b7280" }} />}
              sx={{
                padding: "16px 24px",
                "& .MuiAccordionSummary-content": {
                  margin: "0 !important",
                },
              }}
            >
              <span className="text-lg font-semibold text-gray-800">Privacy Policy</span>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0 24px 24px 24px", backgroundColor: "transparent" }}>
              <div className="max-h-[500px] overflow-y-auto border-t pt-4">
                <PrivacyPolicyContent />
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </>
  );
};

export default LegalTab;
